module.exports = __webpack_public_path__ + "img/17.78e7fad0.png";